import { render, staticRenderFns } from "./action-btn.vue?vue&type=template&id=34a5c36f&scoped=true"
import script from "./action-btn.vue?vue&type=script&lang=ts"
export * from "./action-btn.vue?vue&type=script&lang=ts"
import style0 from "./action-btn.vue?vue&type=style&index=0&id=34a5c36f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a5c36f",
  null
  
)

export default component.exports